import { createContext, ReactNode, useContext, useState } from "react";
import { getInitialDuckVisibility, persistVisibility } from "duck/ui/utils";

interface DuckContextType {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const DEFAULT_DUCK_CONTEXT: DuckContextType = {
  open: getInitialDuckVisibility(),
  setOpen: () => {},
};

const DuckContext = createContext<DuckContextType>(DEFAULT_DUCK_CONTEXT);

interface DuckProviderProps {
  children: ReactNode;
}

export const DuckProvider = ({ children }: DuckProviderProps) => {
  const [open, setOpenState] = useState(getInitialDuckVisibility);
  const setOpen = (isOpen: boolean): void => {
    setOpenState(isOpen);
    persistVisibility(isOpen);
  };

  return (
    <DuckContext.Provider
      value={{
        open,
        setOpen,
      }}
    >
      {children}
    </DuckContext.Provider>
  );
};

export const useDuck = (): DuckContextType => {
  const context = useContext(DuckContext);
  if (context === undefined) {
    throw new Error("useDuck must be used within a DuckProvider");
  }

  return context;
};
